module.exports = __webpack_public_path__ + "05_mid_brown.32383c57.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/05_mid_brown.png
// module id = pchz
// module chunks = 0